import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import {
  createLeadBackground,
  CreateLeadBackgroundApiPayload,
} from '@/actions/leads/createLeadBackground';
import { ApiResponse } from '@/types/response.type';
import { LeadBackground } from '@/types/zee-candidate.type';

export interface UseCreateLeadBackgroundReturn {
  mutate: (
    leadId: string,
    payload: CreateLeadBackgroundApiPayload
  ) => Promise<ApiResponse<LeadBackground> | undefined>;
  result: ApiResponse<LeadBackground> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useCreateLeadBackground = (): UseCreateLeadBackgroundReturn => {
  const queryClient = useQueryClient();

  const mutation: UseMutationResult<
    ApiResponse<LeadBackground> | undefined,
    Error,
    {
      leadId: string;
      payload: CreateLeadBackgroundApiPayload;
    }
  > = useMutation({
    mutationFn: ({ leadId, payload }) => createLeadBackground(leadId, payload),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['user-background', variables.leadId],
      });
    },
  });

  return {
    mutate: (leadId, payload) => mutation.mutateAsync({ leadId, payload }),
    result: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
